<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Computer Engineering"
                   :links="[{title:'Home', url:'/'},{title:'Vision Mission'}]"></page-header>
        <div class="container-2">
          <section class="sidebar">
            <sidebar :active="2"></sidebar>
          </section>
          <section class="content">
            <div class="heading-black1">Vision Mission</div>
            <div class="relative flex flex-col min-w-0 break-words w-full mb-6">
              <div class="shadow-md">
                <h4 class="text-3xl font-semibold w-full bg-pink-700 p-2 text-white text-center">Vision</h4>
                <div class="w-full bg-white border-2 border-gray-50 p-4 text-gray-600 font-semibold">
                  <blockquote>
                    Producing the students which would be globally recognized as innovative and well-prepared computing professionals & trained in the latest technologies and striving to make India a world leader in software and hardware products and services.
                  </blockquote>
                </div>
              </div>
              <div class="shadow-md mt-10">
                <h4 class="text-3xl font-semibold w-full bg-pink-700 p-2 text-white text-center">Mission</h4>
                <div class="w-full bg-white border-2 border-gray-50 px-2">
                  <ul class="list-reset text-black mb-8 p-4 text-gray-600 font-sans font-semibold">
                    <li class="flex items-center mb-3">
                      <div class="rounded-full border-2 bg-gray-600  p-1 mr-2 shadow-md">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 text-white" viewBox="0 0 20 20"
                             fill="currentColor">
                          <path fill-rule="evenodd"
                                d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                                clip-rule="evenodd"/>
                        </svg>
                      </div>
                      <p class="text-justify">
                        To achieve academic excellence in Computer Engineering by imparting in-depth knowledge to the students, facilitating research activities and cater to the ever changing industrial demands and the most important societal needs.
                      </p>
                    </li>
                    <li class="flex items-center mb-3">
                      <div class="rounded-full border-2 bg-gray-600 p-1 mr-2 shadow-md">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 text-white" viewBox="0 0 20 20"
                             fill="currentColor">
                          <path fill-rule="evenodd"
                                d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                                clip-rule="evenodd"/>
                        </svg>
                      </div>
                      <p class="text-justify">
                        To train the students in different aspects of computing discipline and to offer other training programs to enhance, augment, and/or update technical skills of stake holders.
                      </p>
                    </li>
                    <li class="flex items-center mb-3">
                      <div class="rounded-full border-2 bg-gray-600 p-1 mr-2 shadow-md">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 text-white" viewBox="0 0 20 20"
                             fill="currentColor">
                          <path fill-rule="evenodd"
                                d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                                clip-rule="evenodd"/>
                        </svg>
                      </div>
                      <p class="text-justify">
                        To enrich human resources of the nation with efficient and effective technical manpower in Computer Engineering.
                      </p>
                    </li>
                    <li class="flex items-center mb-3">
                      <div class="rounded-full border-2 bg-gray-600 p-1 mr-2 shadow-md">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 text-white" viewBox="0 0 20 20"
                             fill="currentColor">
                          <path fill-rule="evenodd"
                                d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                                clip-rule="evenodd"/>
                        </svg>
                      </div>
                      <p class="text-justify">
                        To have high quality faculty and staff with an appropriate know how and degrees with a commitment to remain professionally advanced through ongoing research and professional development programs. To motivate the students and faculty for ethical practices.
                      </p>
                    </li>
                  </ul>

                </div>
              </div>
            </div>
          </section>
        </div>
        <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>

<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/computer/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";
export default {
  name: "Vision_Mission",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    KeyRecruiters
  },
  data() {
    return {
    }
  }
}
</script>
<style lang="scss" scoped />
